module.exports = __webpack_public_path__ + "static/media/jet.801a2244.svg";